import isLoading from './is-loading'
import addError from '../ac/add-error'
import { loadMoreNotifications } from '../action/set-notifications'
import requestNotifications from '@app/request/notifications'
import store from '../store'

export default () => {
  return async (dispatch) => {
    const { auth, notifications } = store.getState()
    const limit = 20

    dispatch(isLoading('load-notifications'))

    const result = await requestNotifications(
      { offset: notifications ? notifications.length : 0, limit },
      auth
    )
    if (result.error) {
      dispatch(addError(result.error))
    } else {
      dispatch(loadMoreNotifications(result))
    }

    dispatch(isLoading('load-notifications', true))

    const hasMore = !result.error && result.length === limit
    return hasMore
  }
}
